import { render, staticRenderFns } from "./MainSelect.vue?vue&type=template&id=5ff98a36&scoped=true"
import script from "./MainSelect.vue?vue&type=script&lang=js"
export * from "./MainSelect.vue?vue&type=script&lang=js"
import style0 from "./MainSelect.vue?vue&type=style&index=0&id=5ff98a36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff98a36",
  null
  
)

export default component.exports